module.exports = __webpack_public_path__ + "static/img/software15.40d3d82b.png";